/**
 * Leaflet zoom at/above which investment markers are never clustered (district-level view).
 * Below this zoom, `leaflet.markercluster` groups dense pins (city / metro overview).
 */
export const MARKER_CLUSTER_DISABLE_ZOOM = 16;
